import React, { useEffect } from 'react';
import { useNavigate } from 'react-router'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import Summary from 'components/Summary/Summary'
import ButtonCancelApplication from 'components/Buttons/ButtonCancelApplication/ButtonCancelApplication'
import ButtonPreviousStep from 'components/Buttons/ButtonPreviousStep/ButtonPreviousStep'
import { AppLinks } from 'enviroment/AppLinks'
import useIsMobile from 'common/hooks/useIsMobile'
import { changeApplicationStep, setCurrentStepperMode } from 'store/ApplicationSlice/ApplicationSlice'
import { PAGE_STEPER_STAGES, PAGE_STEPPER_MODES } from 'components/Navbar/pageSteps'
import { ChooseIdentityMethodTypes, IChooseIdentityMethodPageProps, IChooseIdentityMethodSectionProps, SelectedIdentityMethodTypes } from './ChooseIdentityMethodPageProps'
import { SessionStorage } from 'common/CookieStorage'
import { STORAGEKEYS } from 'enviroment/Keys'
import useTextContents from 'common/hooks/useTextContents'
import analyticsService from 'service/AnalyticsService/AnalyticsService'
import { AppState } from 'store'
import { collectBikData } from 'common/helpers/collectBikData'
import { isTrastiBroker } from 'common/helpers/helpers'

import ChooseFormIcon from 'assets/icons/choose-form-icon.svg'
import ChooseMobywatelIcon from 'assets/icons/choose-mobywatel-icon.svg'
import ChooseVideoVerificationIcon from 'assets/icons/choose-video-verification-icon.svg'
import ChooseBankVerificationIcon from 'assets/icons/choose-bank-verification-icon.svg'
import './ChooseIdentityMethodPageStyles.scss'
import  './safari.css'



/**
 * Nadpisanie globalnego interface'u window na potrzeby Kontomatika oraz skryptu BIK CFD 
*/
declare global {
   interface Window {
     ptadx: {
       ptinitiate: Function;
       ptvalidate: Function;
     }
   }
}


const ChooseIdentityButtons = (props: IChooseIdentityMethodSectionProps) => {
   const { isIdentityPage, handleOnIdentityMethodSelect, chooseIdentityPageTextContents } = props
   const sessionStorage = new SessionStorage()
   const isVideoVerificationDisabled = sessionStorage.get(STORAGEKEYS.IS_VIDEO_VERIFICATION_DISABLED) === 'true'


   const handleGetThirdButtonLink = () => {
      if(isIdentityPage) {
         return AppLinks.basicInfoForm
      }
      else {
         if(isTrastiBroker()) {
            return AppLinks.trastiCollectPersonalIdForm
         }
         else {
            return AppLinks.bmverify
         }
      }
   }

   return (
      <div className='choose-identity-section-choose-identity-buttons-wrapper'>
         <Link 
            to={isIdentityPage ? AppLinks.mObywatelIdentityMethod : AppLinks.mObywatelVerificationMethod}  
            className='choose-identity-section-choose-identity-button' 
            id={isIdentityPage? "mObywatel-identity-button" : ""} 
            onClick={() => handleOnIdentityMethodSelect(SelectedIdentityMethodTypes.MOBYWATEL)}  
         >
            <div className='choose-identity-section-choose-identity-button-inner-wrapper'>
               <img src={ChooseMobywatelIcon} alt="img" />
               <p>
                  {isIdentityPage?  chooseIdentityPageTextContents('chooseIdentityMethodPage.identity.mainButton.headingText') : chooseIdentityPageTextContents('chooseIdentityMethodPage.verification.mainButton.headingText')}
               </p>
               <p>
                  {isIdentityPage?  chooseIdentityPageTextContents('chooseIdentityMethodPage.identity.mainButton.secondaryText') : chooseIdentityPageTextContents('chooseIdentityMethodPage.verification.mainButton.secondaryText')}
               </p>
            </div>
         </Link>
         <Link 
            to={isIdentityPage ? AppLinks.videoVerificationStartIdentificationPage : AppLinks.videoVerificationStartVerificationPage} 
            className='choose-identity-section-choose-identity-button' 
            onClick={() => !isVideoVerificationDisabled && handleOnIdentityMethodSelect(SelectedIdentityMethodTypes.VIDEO_VERIFICATION)}
         >
            <div className='choose-identity-section-choose-identity-button-inner-wrapper'>
               <img src={ChooseVideoVerificationIcon} alt="img"/>
               <p>
                  {isIdentityPage?  chooseIdentityPageTextContents('chooseIdentityMethodPage.identity.secondaryButton.headingText') : chooseIdentityPageTextContents('chooseIdentityMethodPage.verification.secondaryButton.headingText')}
               </p>
               <p>
                  {isIdentityPage?  chooseIdentityPageTextContents('chooseIdentityMethodPage.identity.secondaryButton.secondaryText') : chooseIdentityPageTextContents('chooseIdentityMethodPage.verification.secondaryButton.secondaryText')}
               </p>
            </div>
         </Link>
         <Link
            to={handleGetThirdButtonLink()}
            className={`choose-identity-section-choose-identity-button ${isVideoVerificationDisabled && 'identity-button-disabled'}`} 
            onClick={() => handleOnIdentityMethodSelect(SelectedIdentityMethodTypes.DEFAULT_METHOD)}
         >
            <div className='choose-identity-section-choose-identity-button-inner-wrapper'>
               <img src={isIdentityPage? ChooseFormIcon : ChooseBankVerificationIcon} alt="img" />
               <p>
                  {isIdentityPage?  chooseIdentityPageTextContents('chooseIdentityMethodPage.identity.thirdButton.headingText') : chooseIdentityPageTextContents('chooseIdentityMethodPage.verification.thirdButton.headingText')}
               </p>
               <p>
                  {isIdentityPage?  chooseIdentityPageTextContents('chooseIdentityMethodPage.identity.thirdButton.secondaryText') : chooseIdentityPageTextContents('chooseIdentityMethodPage.verification.thirdButton.secondaryText')}
               </p>
            </div>
         </Link>
      </div>
   )
}

const ChooseIdentitySection = (props: IChooseIdentityMethodSectionProps): JSX.Element => {
   const navigate = useNavigate()
   const { isIdentityPage, handleOnIdentityMethodSelect, chooseIdentityPageTextContents } = props

   return (
      <section className='choose-identity-section-outer-wrapper'>
         <div className='choose-identity-section-header-wrapper'>
            <h1>
               {isIdentityPage ? chooseIdentityPageTextContents('chooseIdentityMethodPage.identity.header') : chooseIdentityPageTextContents('chooseIdentityMethodPage.verification.header')}
            </h1>
            <p>
               {isIdentityPage ? chooseIdentityPageTextContents('chooseIdentityMethodPage.identity.mainContent') : chooseIdentityPageTextContents('chooseIdentityMethodPage.verification.mainContent')}
            </p>
         </div>
         <ChooseIdentityButtons 
            isIdentityPage={isIdentityPage} 
            handleOnIdentityMethodSelect={handleOnIdentityMethodSelect} 
            chooseIdentityPageTextContents={chooseIdentityPageTextContents}
         />
         {isIdentityPage && <ButtonPreviousStep canStepBack={true} previousStepUrlPath={AppLinks.productPage} navigate={navigate} />}
         <ButtonCancelApplication />
      </section>
   )
}


const ChooseIdentityMethodPage = (props: IChooseIdentityMethodPageProps): JSX.Element => {
   const sessionStorage = new SessionStorage()
   const navigate = useNavigate()
   const dispatch = useDispatch()
   const chooseIdentityPageTextContents = useTextContents()
   const isMobileDevice = useIsMobile()
   const isIdentityPage = Boolean(props.chooseIdentityMethodType === ChooseIdentityMethodTypes.IDENTITY) // Jeśli isIdentityPage = true - oznacza to stronę wyboru formularza, jeśli = false - wyboru banku
   const analyticsEventTypesNames = useSelector((state: AppState) => state.globalConfigurationState.analyticsEventTypesNames)
   const currentBillingCompany = useSelector((state: AppState) => state.applicationState.billingCompany)

   useEffect(() => {
      dispatch(setCurrentStepperMode(PAGE_STEPPER_MODES.DEFAULT)) // Na stronie wyboru metody weryfikacji, zawsze mamy domyślny navbar

      isIdentityPage && window.ptadx.ptinitiate(null) //Inicjalizacja skryptu BIK CFD 

      dispatch(changeApplicationStep(isIdentityPage || isTrastiBroker()? PAGE_STEPER_STAGES.FORM : PAGE_STEPER_STAGES.BANK_VERIFICATION))
   }, [])


   const handleOnIdentityMethodSelect = async(selectedIdentityMethod: SelectedIdentityMethodTypes) => {
      switch(selectedIdentityMethod){
         case SelectedIdentityMethodTypes.DEFAULT_METHOD: {
            // Sytuacja gdy jesteśmy na stronie wyboru formularza, UŻYTKOWNIK BYŁ JUŻ NA STRONIE MOBYWATELA, cofnął się i WYBIERA STANDARDOWY FORMULARZ, 
            const isUserVisitedMobywatelPage = sessionStorage.get(STORAGEKEYS.MOBYWATEL_IS_AFTER_FIRST_RENDER) === 'true'
            isIdentityPage && isUserVisitedMobywatelPage && analyticsEventTypesNames !== undefined && analyticsService.sendAnalyticEvent(analyticsEventTypesNames.MobywatelBackToChooseIdentyficationMethod)
            
            dispatch(setCurrentStepperMode(PAGE_STEPPER_MODES.DEFAULT)) // Ustawiamy odpowiedni stepper dla wybranej metody weryfikacji

            break;
         }
         case SelectedIdentityMethodTypes.MOBYWATEL: {
            dispatch(setCurrentStepperMode(PAGE_STEPPER_MODES.MOBYWATEL)) // Ustawiamy odpowiedni stepper dla wybranej metody weryfikacji

            break;
         }
         case SelectedIdentityMethodTypes.VIDEO_VERIFICATION: {
            if(isIdentityPage) {
               analyticsService
                  .createSingleAnalyticEvent(analyticsEventTypesNames?.IdentificationVideoVerificationMethodSelect)
                  .catch(error => console.warn('Nie udało się zapisać eventu wyboru wideoweryfikacji.', error))
            }

            dispatch(setCurrentStepperMode(PAGE_STEPPER_MODES.DEFAULT)) // Ustawiamy odpowiedni stepper dla wybranej metody weryfikacji

            break;
         }
         default: return 
      }

      collectBikData()
   }

   return (
      <div className='choose-identity-method-page-main-wrapper choose-identity-method-safari-only'>
         <ChooseIdentitySection 
            isIdentityPage={isIdentityPage} 
            handleOnIdentityMethodSelect={handleOnIdentityMethodSelect} 
            chooseIdentityPageTextContents={chooseIdentityPageTextContents}
         />
         {!isMobileDevice && <Summary isExtended={true} />}
         { isIdentityPage && <input type="hidden" id="ptsuser_prefs" name="ptsuser_prefs" />   /* Dodane na potrzeby skryptu BIK CFD NIE ZMIENIAĆ*/}
         { isIdentityPage && <input type="hidden" id="ptsuser_prefs2" name="ptsuser_prefs2" /> /* Dodane na potrzeby skryptu BIK CFD NIE ZMIENIAĆ*/}
      </div>
   )
}

export default ChooseIdentityMethodPage
